import React, {useEffect, useState} from 'react';
import UserAboutForm from './UserAboutForm.jsx';
import IsFetchingInline from '../../common/IsFetchingInline.jsx';

const UserAbout = (props) => {
  let [editMode, setEditMode] = useState(false);
  let [userAbout, setUserAbout] = useState(props.userAbout);

  useEffect(() => {
    setUserAbout(props.userAbout)
  }, [props.userAbout]);

  const handleClick = (event) => {
    setEditMode(true);
  };

  const handleSubmit = (formData) => {
    setEditMode(false);
    props.onSubmit(formData);
  };

  const handleReset = () => {
    setEditMode(false);
  };

  let userAboutBlock;
  if (userAbout) {
    userAboutBlock = <div onClick={handleClick} title={gettext('Кликните на текст для редактирования информации')}>
      <div className="cabinet-editable__text">{props.userAbout}</div>
    </div>
  } else {
    userAboutBlock = <div>
      <button type="button"
              className="btn btn-link btn-sm"
              title={gettext('Добавить информацию о себе')}
              onClick={handleClick}>
        {gettext('Добавить информацию о себе')} <i className="icon icon-plus"></i>
      </button>
    </div>
  }

  return <div className="cabinet-editable">
    <div className="font-weight-bold">{gettext('О себе')}:</div>
    <p className="small text-secondary">{gettext('Кликните на текст для редактирования информации')}</p>
    {!editMode &&  userAboutBlock}
    {editMode && <UserAboutForm onSubmit={handleSubmit} onReset={handleReset}/>}
    <IsFetchingInline isFetching={props.isFetching}/>
  </div>
}

export default UserAbout;